import { AnimationWrapper, Body, Close, Container, Impact, Pulse, Title } from "./styles";

interface ToastProps {
  title: string;
  description?: string;
  type?: "success" | "error" | "info";
  onClose?: () => void;
}

export default function Toast({ title, description, type, onClose }: ToastProps) {
  return (
    <Container type={type}>
      <Body>
        <Title>
          <AnimationWrapper>
            <Impact />
            <Pulse />
          </AnimationWrapper>
          <span>{title}</span>
        </Title>
        {description && (
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}
      </Body>
      <Close onClick={onClose} />
    </Container>
  );
}
